import React from "react";

const CloseSearchApi = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_2359_623)">
        <path
          d="M3 11C3 6.58172 6.58172 3 11 3V3C15.4183 3 19 6.58172 19 11V11C19 15.4183 15.4183 19 11 19V19C6.58172 19 3 15.4183 3 11V11Z"
          fill="#5F67E0"
        />
      </g>
      <path
        d="M11.7065 11.0009L13.8557 8.85672C13.9498 8.76261 14.0027 8.63496 14.0027 8.50186C14.0027 8.36876 13.9498 8.24111 13.8557 8.14699C13.7616 8.05287 13.6339 8 13.5008 8C13.3677 8 13.2401 8.05287 13.146 8.14699L11.0018 10.2962L8.85758 8.14699C8.76346 8.05287 8.63581 8 8.50271 8C8.36961 8 8.24196 8.05287 8.14784 8.14699C8.05373 8.24111 8.00085 8.36876 8.00085 8.50186C8.00085 8.63496 8.05373 8.76261 8.14784 8.85672L10.297 11.0009L8.14784 13.1451C8.101 13.1916 8.06381 13.2469 8.03844 13.3078C8.01306 13.3687 8 13.434 8 13.5C8 13.566 8.01306 13.6313 8.03844 13.6922C8.06381 13.7531 8.101 13.8084 8.14784 13.8548C8.19431 13.9017 8.24959 13.9389 8.31049 13.9642C8.3714 13.9896 8.43673 14.0027 8.50271 14.0027C8.56869 14.0027 8.63402 13.9896 8.69493 13.9642C8.75583 13.9389 8.81111 13.9017 8.85758 13.8548L11.0018 11.7057L13.146 13.8548C13.1924 13.9017 13.2477 13.9389 13.3086 13.9642C13.3695 13.9896 13.4348 14.0027 13.5008 14.0027C13.5668 14.0027 13.6321 13.9896 13.693 13.9642C13.754 13.9389 13.8092 13.9017 13.8557 13.8548C13.9025 13.8084 13.9397 13.7531 13.9651 13.6922C13.9905 13.6313 14.0035 13.566 14.0035 13.5C14.0035 13.434 13.9905 13.3687 13.9651 13.3078C13.9397 13.2469 13.9025 13.1916 13.8557 13.1451L11.7065 11.0009Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_2359_623"
          x="0.625"
          y="0.625"
          width="20.75"
          height="20.75"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.1875" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2359_623"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2359_623"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default CloseSearchApi;
